module.exports = __webpack_public_path__ + "img/PQC+Logo.724914fa.png";